/*
  Colour combination facet
  ------------------------
  The ImageAlt filter values are combinations like ["black","white"].
  snippets/color-combo-facet.liquid renders one chip per single colour and keeps
  Shopify's real checkboxes hidden in the same form.

  Flow when a colour is picked:
    1. hide the grid and start the spinner
    2. tick the matching hidden checkboxes and let facets.js fetch the new grid
    3. when the new grid arrives, switch each card to the ticked colour and drop
       the cards that have nothing in that colour
    4. reveal everything in one go

  Nothing is shown between steps 1 and 4, so there is no flash of the old grid
  and no second visible refresh.
*/
(function () {
  var KEY = 'comboFacetColors';

  var busyTimer;
  var applying = false; // true while we are clicking swatches ourselves
  var pending = false; // true from the moment a colour is picked until the grid lands

  function readStored() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function writeStored(colors, last) {
    try {
      localStorage.setItem(KEY, JSON.stringify(colors));
      localStorage.setItem(KEY + 'Last', last || '');
    } catch (e) {
      /* private mode, ignore */
    }
    window.comboFacetColors = colors;
    window.comboFacetLastColor = last || null;
  }

  function injectStyles() {
    if (document.getElementById('combo-facet-styles')) return;
    var css =
      '#FacetsWrapperDesktop{overflow-x:hidden;overflow-y:auto}' +
      '#ProductGridContainer .collection{opacity:1;transition:opacity .15s ease}' +
      '#ProductGridContainer.combo-busy .collection{opacity:0;transition:none}' +
      // While the spinner runs it sits on top of the results count, so the
      // count is nudged left to leave room for it.
      '.product-count__text{transition:padding-right .15s ease}' +
      'body.combo-loading .product-count__text{padding-right:2.6rem}' +
      '[data-combo-pills]{display:contents}' +
      '[data-combo-remove]{cursor:pointer;margin:0;text-decoration:none}' +
      '[data-combo-remove] .active-facets__button-inner{transition:none}' +
      '[data-combo-remove] svg{margin-left:.5rem;flex-shrink:0}';
    var tag = document.createElement('style');
    tag.id = 'combo-facet-styles';
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  function chipsIn(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('[data-combo-color]'));
  }

  function activeColors(scope) {
    return chipsIn(scope)
      .filter(function (chip) {
        return chip.getAttribute('data-combo-active') === 'true';
      })
      .map(function (chip) {
        return chip.getAttribute('data-combo-color');
      });
  }

  function setChip(chip, on) {
    chip.setAttribute('data-combo-active', on ? 'true' : 'false');
    chip.classList.toggle('active', on);
  }

  function scopeOf(node) {
    return (node && node.closest('.parent-display, .mobile-facets__submenu')) || document;
  }

  // Which hidden values should be ticked for this set of colours
  function wanted(scope, colors) {
    return Array.prototype.slice.call(scope.querySelectorAll('[data-combo-input]')).filter(function (input) {
      var key = input.getAttribute('data-combo-key') || ',';
      return colors.some(function (c) {
        return key.indexOf(',' + c + ',') !== -1;
      });
    });
  }

  function syncInputs(scope, colors) {
    var want = wanted(scope, colors);
    var changed = null;
    scope.querySelectorAll('[data-combo-input]').forEach(function (input) {
      var should = want.indexOf(input) !== -1;
      if (input.checked !== should) {
        input.checked = should;
        changed = input;
      }
    });
    return changed;
  }

  // ----------------------------------------------------------------
  // Loader
  // ----------------------------------------------------------------

  function spinners() {
    return document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
  }

  function setBusy(on) {
    var grid = document.getElementById('ProductGridContainer');
    if (grid) grid.classList.toggle('combo-busy', on);

    // The results count sits outside the grid container, so it needs its own
    // hook to make room for the spinner
    document.body.classList.toggle('combo-loading', on);

    spinners().forEach(function (sp) {
      sp.classList.toggle('hidden', !on);
    });

    clearTimeout(busyTimer);
    if (on) {
      // Never leave the grid hidden if the request fails
      busyTimer = setTimeout(function () {
        pending = false;
        applying = false;
        setBusy(false);
      }, 5000);
    }
  }

  // ----------------------------------------------------------------
  // Applied filter pills
  // ----------------------------------------------------------------

  function updateFilterCount() {
    var holder = document.querySelector('.filter-active-count');
    if (!holder) return;

    var others = document.querySelectorAll(
      '#FacetsWrapperDesktop facet-remove:not(.active-facets__button-wrapper)'
    ).length;

    var ui = document.querySelector('.parent-display [data-combo-ui]');
    var colors = ui ? activeColors(scopeOf(ui)).length : 0;

    var total = others + colors;
    var text = total > 0 ? ' (' + total + ')' : '';
    if (holder.innerHTML !== text) holder.innerHTML = text;
  }

  // A URL without this colour, used only as a fallback when the facet column is
  // not on the page. Normally the pill goes through the AJAX path instead.
  function buildUrl(scope, colors) {
    var inputs = Array.prototype.slice.call(scope.querySelectorAll('[data-combo-input]'));
    if (!inputs.length) return window.location.href;

    var param = inputs[0].getAttribute('name');
    var url = new URL(window.location.href);
    url.searchParams.delete(param);

    inputs.forEach(function (input) {
      var key = input.getAttribute('data-combo-key') || ',';
      var keep = colors.some(function (c) {
        return key.indexOf(',' + c + ',') !== -1;
      });
      if (keep) url.searchParams.append(param, input.getAttribute('value'));
    });

    return url.pathname + (url.search ? url.search : '');
  }

  function renderPills() {
    var holder = document.querySelector('[data-combo-pills]');
    if (!holder) return;
    var ui = document.querySelector('.parent-display [data-combo-ui]');
    if (!ui) {
      if (holder.innerHTML !== '') holder.innerHTML = '';
      return;
    }

    var scope = scopeOf(ui);
    var colors = activeColors(scope);

    var html = colors
      .map(function (c) {
        var label = c.charAt(0).toUpperCase() + c.slice(1);
        var rest = colors.filter(function (other) {
          return other !== c;
        });
        return (
          '<a href="' + buildUrl(scope, rest) + '" ' +
          'class="active-facets__button active-facets__button--light" ' +
          'data-combo-remove="' + c + '">' +
          '<span class="active-facets__button-inner button button--tertiary">' +
          label +
          '<svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" fill="none">' +
          '<path d="M1 1L11 11M11 1L1 11" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>' +
          '</svg></span></a>'
        );
      })
      .join('');

    // Only touch the DOM when it really changes, otherwise the pill is replaced
    // under the cursor and both the hover and the click break.
    if (holder.innerHTML !== html) holder.innerHTML = html;
  }

  // ----------------------------------------------------------------
  // Product cards
  // ----------------------------------------------------------------

  function slideHasColor(slide, color) {
    var dc = (slide.getAttribute('data-color') || '').toLowerCase();
    if (!dc) return false;
    return new RegExp('(^|[-_\\s])' + color + '($|[-_\\s])').test(dc);
  }

  function applyToCards() {
    var grid = document.querySelector('#product-grid');
    if (!grid) {
      pending = false;
      setBusy(false);
      return;
    }

    applying = true;

    var colors = window.comboFacetColors || readStored();
    var key = colors.join('|');

    grid.querySelectorAll('li.grid__item').forEach(function (li) {
      var card = li.querySelector('product-card');
      if (!card) return;

      // Collection banners are product-card too, leave them alone
      if (li.classList.contains('collection-banner-item')) return;

      if (!colors.length) {
        li.hidden = false;
        card.removeAttribute('data-combo-applied');
        return;
      }

      if (card.getAttribute('data-combo-applied') === key) return;

      var slides = card.querySelectorAll('.variant-carousel-product-card .swiper-slide');
      var match = null;

      // First ticked colour wins, then the next one
      for (var i = 0; i < colors.length && !match; i++) {
        for (var j = 0; j < slides.length; j++) {
          if (slideHasColor(slides[j], colors[i])) {
            match = slides[j];
            break;
          }
        }
      }

      card.setAttribute('data-combo-applied', key);

      if (match) {
        li.hidden = false;
        if (!match.classList.contains('active-swatch')) match.click();
      } else {
        li.hidden = true;
      }
    });

    // Let the swatch switching paint, then reveal everything at once
    requestAnimationFrame(function () {
      setTimeout(function () {
        applying = false;
        pending = false;
        setBusy(false);
      }, 30);
    });
  }

  // ----------------------------------------------------------------
  // Chip state, restored after each render
  // ----------------------------------------------------------------

  // The server can only guess the ticked colours from the active combinations,
  // which is ambiguous for a colour that never appears on its own. If what we
  // remembered matches the checkboxes that came back, trust the memory.
  function applyStored() {
    var ui = document.querySelector('.parent-display [data-combo-ui]');
    if (!ui) return;
    var scope = scopeOf(ui);

    var stored = readStored();
    var settled = false;

    if (stored.length) {
      var want = wanted(scope, stored);
      var checked = Array.prototype.slice
        .call(scope.querySelectorAll('[data-combo-input]'))
        .filter(function (i) {
          return i.checked;
        });
      var same =
        want.length === checked.length &&
        want.every(function (i) {
          return checked.indexOf(i) !== -1;
        });
      if (same) {
        chipsIn(document).forEach(function (chip) {
          setChip(chip, stored.indexOf(chip.getAttribute('data-combo-color')) !== -1);
        });
        settled = true;
      }
    }

    if (!settled) writeStored(activeColors(scope), null);

    renderPills();
    updateFilterCount();
  }

  // ----------------------------------------------------------------
  // Interaction
  // ----------------------------------------------------------------

  function toggleChip(chip) {
    if (chip.classList.contains('disabled')) return;

    var scope = scopeOf(chip);
    var color = chip.getAttribute('data-combo-color');
    var on = chip.getAttribute('data-combo-active') !== 'true';

    setChip(chip, on);

    // Keep the desktop and mobile chip for the same colour in step
    document.querySelectorAll('[data-combo-color="' + color + '"]').forEach(function (other) {
      if (other !== chip) setChip(other, on);
    });

    var colors = activeColors(scope);
    writeStored(colors, on ? color : null);
    renderPills();
    updateFilterCount();

    var changed = syncInputs(scope, colors);
    if (!changed) return;

    // Hide the grid and start the spinner BEFORE the request goes out. The
    // cards are only touched once the new grid arrives, so the old one never
    // shows through.
    pending = true;
    setBusy(true);

    changed.dispatchEvent(new Event('input', { bubbles: true }));
    changed.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function onChipClick(event) {
    var chip = event.target.closest('[data-combo-color]');
    if (!chip) return;
    event.preventDefault();
    toggleChip(chip);
  }

  function onPillDown(event) {
    var pill = event.target.closest('[data-combo-remove]');
    if (!pill) return;
    if (event.button && event.button !== 0) return; // middle and right click untouched
    if (event.metaKey || event.ctrlKey || event.shiftKey) return; // open in new tab still works

    event.preventDefault();

    // Untick the chip, which goes down the same AJAX path: no page reload
    var color = pill.getAttribute('data-combo-remove');
    var chip = document.querySelector('.parent-display [data-combo-color="' + color + '"]');
    if (chip) {
      toggleChip(chip);
      return;
    }

    var href = pill.getAttribute('href');
    if (href) window.location.href = href;
  }

  // pointerdown, not click: a click needs the same element under the cursor for
  // press and release, and the facet column can be re-rendered in between.
  document.addEventListener('pointerdown', onPillDown);

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-combo-remove]')) {
      event.preventDefault(); // already handled on pointerdown
      return;
    }
    onChipClick(event);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    var pill = event.target.closest('[data-combo-remove]');
    if (pill) {
      event.preventDefault();
      var pillColor = pill.getAttribute('data-combo-remove');
      var pillChip = document.querySelector('.parent-display [data-combo-color="' + pillColor + '"]');
      if (pillChip) {
        toggleChip(pillChip);
      } else if (pill.getAttribute('href')) {
        window.location.href = pill.getAttribute('href');
      }
      return;
    }

    var chip = event.target.closest('[data-combo-color]');
    if (!chip) return;
    event.preventDefault();
    chip.click();
  });

  // ----------------------------------------------------------------
  // Start
  // ----------------------------------------------------------------

  function start() {
    injectStyles();

    // A colour already in the URL: hide the grid for the first pass too
    if (readStored().length) setBusy(true);
    applyStored();
    applyToCards();

    // The grid is replaced by AJAX filtering and by Show more. Our own swatch
    // clicks also mutate it, and reacting to those would cause a second pass,
    // which is the extra refresh you could see.
    var gridTimer;
    var grid = document.getElementById('ProductGridContainer');
    if (grid) {
      new MutationObserver(function () {
        if (applying) return;
        if (pending || (window.comboFacetColors || []).length) setBusy(true);
        clearTimeout(gridTimer);
        gridTimer = setTimeout(applyToCards, 60);
      }).observe(grid, { childList: true, subtree: true });
    }

    // The facet column is replaced on every filter update, so the chips need
    // their remembered state put back and the pills rebuilt.
    var facetTimer;
    var facets = document.getElementById('FacetsWrapperDesktop');
    if (facets) {
      new MutationObserver(function () {
        clearTimeout(facetTimer);
        facetTimer = setTimeout(applyStored, 60);
      }).observe(facets, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
